import { BannerArt } from '../components/brand/BannerArt.jsx'
import { FadedPhoto } from '../components/brand/FadedPhoto.jsx'
import { Container, Eyebrow } from '../components/ui/primitives.jsx'
import { pickBackground } from '../lib/backgrounds.js'
import { accentStyle, cn } from '../lib/format.js'

// Wide header art that fades into the page through a gradient mask. Uses
// the page's own banner when there is one, then a configured background
// photo, then generated art. `compact` sets a smaller title beside media
// it's centred on, even on phones, for a profile picture. `top` sits above
// the title (a way back), `aside` beside it on wide screens (below on phones).
export function PageHeader({ eyebrow, title, description, image, imageAlt = '', seed, accent, media, compact = false, top, aside, actions, children, className }) {
  const photo = image ? { src: image } : pickBackground('pages', seed ?? title)
  return (
    <header className={cn('relative isolate', className)} style={accentStyle(accent)}>
      {/* The art runs taller than short headers, over the top of the page below,
          so it must never catch clicks meant for what's under it. */}
      <div className="fade-to-page pointer-events-none absolute inset-x-0 top-0 -z-10 h-72 overflow-hidden sm:h-96">
        {photo ? (
          <FadedPhoto src={photo.src} position={photo.position} alt={imageAlt} side="top" strength="subtle" />
        ) : (
          <BannerArt seed={seed ?? title} accent={accent ?? '#f2800d'} className="size-full" />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-page/10 via-page/20 to-page" />
      </div>
      <Container className="pt-24 pb-8 sm:pt-32">
        {top && <div className="mb-4">{top}</div>}
        <div className={cn(aside && 'flex flex-col gap-5 lg:flex-row lg:items-start lg:justify-between')}>
          <div className={cn(media && (compact ? 'flex items-center gap-4 sm:gap-7' : 'flex flex-col gap-5 sm:flex-row sm:items-end sm:gap-7'))}>
            {media && <div className="shrink-0">{media}</div>}
            <div className="min-w-0">
              {eyebrow && <Eyebrow className="tint-text">{eyebrow}</Eyebrow>}
              <h1 className={cn('mt-2 font-display font-semibold tracking-wide break-words uppercase', compact ? 'text-3xl sm:text-4xl' : 'text-4xl sm:text-5xl')}>{title}</h1>
              {description && <p className="mt-3 max-w-2xl text-base text-ink-muted sm:text-lg">{description}</p>}
            </div>
          </div>
          {aside && <div className="shrink-0">{aside}</div>}
        </div>
        {actions && <div className="mt-6 flex flex-wrap gap-3">{actions}</div>}
        {children}
      </Container>
    </header>
  )
}
